import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
// import Button from '@material-ui/core/Button';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { infoSnackbarState } from "../Atoms/infoSnackbarAtom";
import { useRecoilValue, useSetRecoilState } from "recoil";
// import { ActionCreators as UndoActionCreators } from 'redux-undo';

const InfoSnackbar = () => {
  const infoSnackbar = useRecoilValue(infoSnackbarState);
  const setInfosnackbarState = useSetRecoilState(infoSnackbarState);

  function handleClose() {
    setTimeout(
      () => {
        setInfosnackbarState((oldState) => {
          return {
            ...oldState,
            infoSnackbarOpen: false,
            infoSnackbarBlur: false,
          };
        });
      },
      infoSnackbar.infoSnackbarBlur ? 4000 : 0,
    );
  }

  // function handleUndo() {
  //   handleClose();
  // }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={infoSnackbar.infoSnackbarOpen}
      autoHideDuration={infoSnackbar.infoSnackbarBlur ? 0 : 4000}
      onClose={handleClose}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar">{infoSnackbar.infoSnackbarMessage}</span>
      }
      action={
        <>
          {/* {infoSnackbarUndo && (
          <Button
            color="secondary"
            size="small"
            onClick={handleUndo}
          >
            UNDO
          </Button>
        )} */}
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </>
      }
    />
  );
};

export default InfoSnackbar;
